"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _Recaptcha = _interopRequireDefault(require("../../../packages/Recaptcha"));
var _safeConfig = require("../../packages/config/safe-config");
const useReCaptchaService = function () {
  const {
    REACT_APP_RECAPTCHA_KEY
  } = (0, _safeConfig.useSafeConfigSlice)(["REACT_APP_RECAPTCHA_KEY"]);
  const findReCaptchaToken = (0, _react.useCallback)(async function () {
    await (0, _Recaptcha.default)(REACT_APP_RECAPTCHA_KEY);
    await new Promise(function (resolve, reject) {
      var _window$grecaptcha;
      if (!((_window$grecaptcha = window.grecaptcha) !== null && _window$grecaptcha !== void 0 && _window$grecaptcha.enterprise)) {
        reject("Google reCAPTCHA Enterprise is not defined.");
      }
      window.grecaptcha.enterprise.ready(resolve);
    });
    return window.grecaptcha.enterprise.execute(REACT_APP_RECAPTCHA_KEY, {
      action: "submit"
    });
  }, [REACT_APP_RECAPTCHA_KEY]);
  return {
    findReCaptchaToken
  };
};
var _default = exports.default = useReCaptchaService;